// extracted by mini-css-extract-plugin
export var knife = "style-mod--knife--a88e8";
export var knifeImg = "style-mod--knife-img--22424";
export var knifeImgWrap = "style-mod--knife-img-wrap--c37a5";
export var knifeList = "style-mod--knife-list--834d3";
export var knifeSelected = "style-mod--knife-selected--23fcf";
export var knifeSmall = "style-mod--knife-small--2d25b";
export var knifeVariants = "style-mod--knife-variants--942dc";
export var list = "style-mod--list--956ff";
export var selectedVariant = "style-mod--selected-variant--98b4e";